import React, { useEffect, useState } from 'react';
import { Tab, Tabs, Form, Table } from 'react-bootstrap';
import Open_orders from './tab_components/open_orders';
import Order_history from './tab_components/order_history';
import Trade_history from './tab_components/trade_history';
import './tab_components/tab_style.css'
import { useDispatch, useSelector } from "react-redux";
import { AXIOS, api_key } from "../../config";
import { toast } from "react-toastify";

export default function Tabss() {
    const [orderHistory, setOrderHistory] = useState([])
    const [openOrder, setOpenOrder] = useState([])
    const { isLogin } = useSelector((state: any) => state.auth);

    const { pairName, pairOneSymbol, pairTwoSymbol, symbolOneId, symbolTwoId } = useSelector((state: any) => state.pair);
    const { isCreatedOrder, orderType } = useSelector((state: any) => state.spot)
    let userid = sessionStorage.getItem('userid')
    useEffect(() => {
        if (isLogin) {
            (async function () {

                try {
                    let openOrderResponse = await AXIOS
                        .post(`getOrders?status=1`, {
                            api_key: api_key,
                            // user_id: userid
                        })

                    setOpenOrder(openOrderResponse.data.data)

                } catch (error: any) {
                    //   toast.error(error.message)
                }

            })()
        }


    }, [isCreatedOrder, orderType, isLogin]);

    return (
        <>
            <div className="tabs container-fluid p-0 mt-3 d-flex flex-wrap-sm">
                <div className='row'>
                    <Tabs
                        defaultActiveKey='open'
                        id='uncontrolled-tab-example'
                        className='mb-3 text-start custom_tab'
                    >

                        <Tab
                            eventKey="open" title={`Open Orders ${openOrder.length}`} className='custom_tab_content'
                        >
                            <Open_orders openOrders={openOrder} />
                        </Tab>
                        <Tab
                            eventKey="order" title='Order History' className='custom_tab_content'
                        >
                            <Order_history />
                        </Tab>

                        <Tab
                            eventKey="trade" title={`Trade History ${openOrder.length}`} className='custom_tab_content'
                        >
                            <Trade_history />
                        </Tab>
                    </Tabs>
                    <Table>
                        <tr></tr>
                    </Table>
                </div>
                <section className='tab_chkbox'>
                    <div className="tabss_chk d-flex gap-2 align-items-center m-0 p-0">
                        <Form.Check type='checkbox' />
                        <span style={{ fontSize: '.893em', color: 'var(--text-clr)' }}>Hide Other Pairs</span>
                    </div>
                </section>

            </div>


        </>
    )
}